<template>
  <form-field :name="field.name">
    <v-select
      v-model="field.value"
      :hint="hint"
      :items="states"
      :menu-props="{maxHeight:'250'}"
      v-bind="field.props"
      dense
      box
      label="Select state"
      validate-on-blur
    />
  </form-field>
</template>

<script>
import formField from '@/mixins/form-field'
import { createGetParams } from '@/rest'

export default {
  name: 'StateProviceField',
  mixins: [formField],
  props: {
    value: {
      type: String,
      required: false,
      default: null,
    },
  },
  data () {
    return {
      states: [],
      hint: 'State required',
    }
  },
  mounted: function () {
    this.getStates()
  },
  methods: {
    getStates: function () {
      this.$rest.get('upgrade/getStates.php', createGetParams({}))
        .then(function (response) {
          for (const item of response.data) {
            this.states.push(item.state)
          }
        }.bind(this)).catch(() => {
          // ignore
        })
    },
  },
}
</script>
